import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import React, { memo, useCallback, useState } from 'react';
import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from 'shared/constants/microfrontends';
import { AdBannerMicrofrontendSuburbanListingContainer } from 'shared/containers/AdBannerMicrofrontendSuburbanListingContainer';
import { AdFoxBannerContainer } from 'shared/containers/AdFoxBannerContainer';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { AdfoxContextProviderProps } from '../../utils/AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'between_offers',
};
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 200 };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'czsow', p2: 'y' };

type SuburbanListingBannerProps = {
  position: number;
};

export const SuburbanListingBanner = memo<SuburbanListingBannerProps>(function SuburbanListingBanner(props) {
  const { position } = props;
  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY);

  const [isHidden, setIsHidden] = useState(false);
  const hide = useCallback(() => setIsHidden(true), []);

  if (manifest) {
    if (isHidden) {
      return null;
    }

    return (
      <AdBannerMicrofrontendSuburbanListingContainer
        manifest={manifest}
        position={position}
        onStub={hide}
        onError={hide}
        onClose={hide}
      />
    );
  }

  return (
    <AdFoxBannerContainer
      position={position}
      bannerName="AdFox баннер для загородки"
      size={SIZE}
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    />
  );
});
